import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import RowStack from 'components/atoms/container/RowStack'
import DateTimeStack from '../rolePlay/DateTimeStack'
import { Divider, IconButton, Stack, Typography, useTheme } from '@mui/material'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined'
import { parseToDateTimeObject } from 'utils/formatDateTime'

const ImportMeetingItem = ({ candidate, selected, setSelected }) => {
  const theme = useTheme()
  const { i18n } = useTranslation()
  const parsedTime = timeString =>
    parseToDateTimeObject(timeString, i18n.resolvedLanguage)
  const isSelected = selected.some(
    selectedCandidate =>
      selectedCandidate.masterCalendarEventId ===
      candidate.masterCalendarEventId
  )
  const handleSelectToggle = () => {
    if (!isSelected) {
      setSelected([...selected, candidate])
    } else {
      setSelected(
        selected.filter(
          selectedCandidate =>
            selectedCandidate.masterCalendarEventId !==
            candidate.masterCalendarEventId
        )
      )
    }
  }
  return (
    <BoxWithBackground
      width='100%'
      backgroundColor={
        isSelected ? colors.GoldenYellow50 : theme.palette.background.paper
      }
      sx={{
        borderColor: isSelected ? colors.GoldenYellow200 : colors.Grey200,
        borderWidth: 1,
        borderStyle: 'solid',
        padding: 8,
        borderRadius: 2
      }}>
      <RowStack justifyContent='space-between'>
        <RowStack spacing={8} alignItems='baseline'>
          <DateTimeStack event={candidate} dayMonth={true} />
          <Divider orientation='vertical' flexItem />
          <Stack padding={0}>
            <Typography variant='h3'>{candidate.subject}</Typography>
            <Typography>{candidate.attendee?.email}</Typography>
            <Typography variant='body1Small' color={colors.Grey350}>
              {`${parsedTime(candidate.startTime).format('dddd @ hh:mm A')} - ${parsedTime(candidate.endTime).format('hh:mm A')}`}
            </Typography>
          </Stack>
        </RowStack>
        <IconButton size='large' onClick={handleSelectToggle}>
          {isSelected ? (
            <CheckCircleIcon
              fontSize='large'
              sx={{ color: colors.GoldenYellow400, fontSize: 36 }}
            />
          ) : (
            <RadioButtonUncheckedOutlinedIcon
              fontSize='large'
              sx={{
                color: colors.Grey300,
                strokeWidth: 1,
                stroke: theme.palette.background.paper,
                fontSize: 36
              }}
            />
          )}
        </IconButton>
      </RowStack>
    </BoxWithBackground>
  )
}

export default ImportMeetingItem
